import React from "react";
import { observer } from "mobx-react";
import { Table } from "react-bootstrap";
import { convertSecondsToTime } from "../../utils/helper";
import { useAppStore } from "../../providers/AppStoreProvider";

// @TODO
const TimeStamp = observer(({ timestamp, setCurrentTime }) => {
  return (
    <tr role="button" className="timestamp" onClick={() => setCurrentTime(timestamp.checkpoint)}>
      <td style={{ width: "1%" }}>
        <div
          role="button"
          className="time fw-bold text-center border p-1 px-3 rounded-10"
          onClick={() => setCurrentTime(timestamp.checkpoint)}
        >
          {convertSecondsToTime(timestamp.checkpoint)}
        </div>
      </td>
      <td className="text">{timestamp.content}</td>
    </tr>
  );
});

export const Timeline = observer(({ setCurrentTime }) => {
  const { currentLesson } = useAppStore();

  return (
    currentLesson.video?.timelines.length > 0 && (
      <div className="mb-4">
        <h5 className="fw-bold mb-3">Timeline bài học</h5>
        <Table className="timestamps">
          <tbody>
            {currentLesson.video?.timelines.map((timestamp) => (
              <TimeStamp key={timestamp.id} timestamp={timestamp} setCurrentTime={setCurrentTime} />
            ))}
          </tbody>
        </Table>
      </div>
    )
  );
});
